var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px",
    d: "M14.2049 10.59L9.62492 6L14.2049 1.41L12.7949 0L6.79492 6L12.7949 12L14.2049 10.59Z",
    fill: "#F0EDEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px_2",
    d: "M8.20492 10.59L3.62492 6L8.20492 1.41L6.79492 0L0.794922 6L6.79492 12L8.20492 10.59Z",
    fill: "#F0EDEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstGrey);
export default __webpack_public_path__ + "static/media/firstGrey.331a0a85b08f434d33f5aa9426df5cb8.svg";
export { ForwardRef as ReactComponent };